import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { fi32, IFrameInfo } from '../main/frameInfo'

let data: ITileDataShip[] = []

function getTiledGroup(y: number, x: number) {
  let fis: IFrameInfo[] = []
  for (let j = 0; j < 6; j++) {
    for (let i = 0; i < 3; i++) {
      fis.push(fi32(8, y + j, x + i))
    }
  }
  return fis
}

interface IStandard {
  hull: ITileDataShip
  floor: ITileDataShip
  tube: ITileDataShip
  asteroid: ITileDataShip
}
let _standard: IStandard | null = null

export function getStandard() {
  if (!_standard) {
    _standard = {
      hull: getByName('ship-hull1'),
      floor: getByName('ship-floor1'),
      tube: getByName('jefferies'),
      asteroid: getByName('asteroid'),
    }
  }
  return _standard
}

export function create() {
  let scene = common.getPhaserScene()
  let json = scene.cache.json.get('tiles')
  // console.log('TILEs json', json)

  data.push({
    idx: 0,
    frameInfo: fi32(5, 1, 1),
    name: 'invalid',
    path: 'invalid',
  })

  data.push({
    idx: 1,
    frameInfo: fi32(8, 2, 1),
    name: 'ship-grid',
    isStructure: true,
  })
  data.push({
    idx: 2,
    frameInfo: fi32(8, 1, 5),
    name: 'ship-structure',
    isStructure: true,
    outsideCost: 10,
  })

  data.push({
    idx: 3,
    frameInfo: fi32(8, 1, 3),
    name: 'ship-floor1',
    buildName: 'Corridor',
    buildDesc: 'Move around and build machines here',
    isFloor: true,
    outsideCost: 20,
    tiledFrameInfo: getTiledGroup(1, 11),
  })

  data.push({
    idx: 4,
    frameInfo: fi32(8, 1, 4),
    name: 'jefferies',
    buildName: "Jefferie's Tube",
    buildDesc: 'Move up and down in the ship',
    isFloor: true,
    outsideCost: 15,
  })

  data.push({
    idx: 5,
    frameInfo: fi32(8, 1, 2),
    name: 'ship-hull1',
    buildName: 'Hull',
    buildDesc: "Protects your ship's squishy innards",
    isFloor: true,
    isHull: true,
    outsideCost: 20,
    tiledFrameInfo: getTiledGroup(1, 8),
  })
  data.push({
    idx: 6,
    frameInfo: fi32(8, 1, 17),
    name: 'asteroid',
    buildName: 'Asteroid',
    buildDesc: 'Part of a large asteroid',
    isFloor: true,
    isHull: true,
    outsideCost: 1000,
    tiledFrameInfo: getTiledGroup(1, 17),
    tiledFrameInfo2: getTiledGroup(1, 20),
  })
  // l.forEach(json.tiles, (c) => {
  //   c.frameInfo = fi32(3, c.y, c.x)
  //   data.push(c)
  // })
}

export function getByName(name: string) {
  let td = l.find(data, (c) => c.name === name)
  if (!td) {
    throw new Error('not found ' + name)
  }
  return td
}

export function getByIndex(idx: number) {
  if (idx <= 0) {
    return null
  }
  return data[idx]
}

export interface ITileDataShip {
  isStructure?: boolean
  isFloor?: boolean
  isObject?: boolean
  isShadow?: boolean
  isDoor?: boolean
  isHull?: boolean
  path?: string
  frameInfo: IFrameInfo
  tiledFrameInfo?: IFrameInfo[]
  tiledFrameInfo2?: IFrameInfo[]
  idx: number
  name: string
  outsideCost?: number

  buildName?: string
  buildDesc?: string
}

export const getStructures = (): ITileDataShip[] => {
  return l.filter(data, (c) => c.isStructure === true)
}
export const getFloors = (): ITileDataShip[] => {
  return l.filter(data, (c) => c.isFloor === true)
}
export const getObjects = (): ITileDataShip[] => {
  return l.filter(data, (c) => c.isObject === true)
}
export const getShadows = (): ITileDataShip[] => {
  return l.filter(data, (c) => c.isShadow === true)
}
export const getDoors = (): ITileDataShip[] => {
  return l.filter(data, (c) => c.isDoor === true)
}
export const getUi = (): ITileDataShip[] => {
  return l.filter(data, (c) => c.path === 'ui')
}
